import { Link } from "@remix-run/react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "~/components/ui/card";
import { Input } from "~/components/ui/input";

import { Button } from "../ui/button";
import type { FormFieldType } from "./form-builder";
import FormBuilder from "./form-builder";

export function LoginForm({
  error,
  userType = "coach",
}: {
  error: string | undefined;
  userType?: "coach" | "admin";
}): JSX.Element {
  const forgotPasswordRoute =
    userType === "admin" ? "/admin-forgot-password" : "/coach-forgot-password";
  const loginFields: FormFieldType[] = [
    {
      id: "login-email",
      label: "Sähköposti",
      type: "email",
      name: "email",
      placeholder: "nimi@esimerkki.fi",
      required: true,
      screenReaderDescription:
        "Syötä sähköpostiosoitteesi kirjautumista varten",
      Component: Input,
    },
    {
      id: "login-password",
      label: "Salasana",
      type: "password",
      name: "password",
      placeholder: "••••••••",
      error: error,
      required: true,
      screenReaderDescription: "Syötä salasanasi kirjautumista varten",
      Component: Input,
    },
    {
      id: "login-submit",
      type: "submit",
      name: "submit",
      Component: Button,
      className: "w-full",
      label: "",
      screenReaderDescription: "Kirjaudu sisään sovellukseen",
      children: "Kirjaudu sisään",
    },
  ];

  return (
    <Card className="w-[350px]" role="main" aria-labelledby="login-title">
      <CardHeader>
        <CardTitle id="login-title">Kirjaudu sisään</CardTitle>
        <CardDescription>Syötä kirjautumistietosi jatkaaksesi</CardDescription>
      </CardHeader>
      <CardContent>
        <FormBuilder fields={loginFields} />
        <div className="mt-4 text-center">
          <Link
            to={forgotPasswordRoute}
            className="text-sm text-muted-foreground hover:underline"
          >
            Unohditko salasanasi?
          </Link>
        </div>
      </CardContent>
    </Card>
  );
}
